import { useState } from "react";
import { Plus } from "lucide-react";
import { can, useAuth } from "../lib/auth";
import { Btn } from "../components/kit/Kit";
import { TaskList, TaskModal } from "../components/crm/Tasks";
import { mezclar, useCopilotoFiltros } from "../lib/copiloto";

export default function Tareas() {
  const { user } = useAuth();
  const [vista, setVista] = useState("mias");
  const [f, setF] = useState({ estado: "", prioridad: "" });
  useCopilotoFiltros("tareas", mezclar(setF, { estado: "", prioridad: "" }), { filtros: f, vista: "Tareas" });
  const [nuevo, setNuevo] = useState(false);
  const [sig, setSig] = useState(0);
  const vistas = [["mias", "Mis tareas"], ["asignadas", "Asignadas por mí"], ...(can(user, "tareas.ver_todas") ? [["todas", "Todas"]] : [])];
  const sel = "rounded-full border border-[#E2DDD5] bg-white px-3 py-1.5 text-sm outline-none focus:border-[#E8643C]";
  return (
    <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-10" data-testid="tareas-page" style={{ animation: "rise .35s ease-out both" }}>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><p className="text-xs font-semibold uppercase tracking-widest text-[#8C867A]">Trabajo del equipo</p>
          <h1 className="font-serif-display mt-1 text-4xl font-bold sm:text-5xl">Tareas<span className="text-[#E8643C]">.</span></h1></div>
        <Btn kind="accent" onClick={() => setNuevo(true)} data-testid="tareas-new"><Plus size={15} /> Nueva tarea</Btn>
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-2">
        <div className="flex rounded-full border border-[#E2DDD5] bg-white p-1" data-testid="tareas-vistas">{vistas.map(([k, l]) => (
          <button key={k} onClick={() => setVista(k)} data-testid={`tareas-vista-${k}`} className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${vista === k ? "bg-[#111] text-white" : "text-[#5C5850] hover:bg-[#F2F0EC]"}`}>{l}</button>))}</div>
        <select value={f.estado} onChange={(e) => setF({ ...f, estado: e.target.value })} className={sel} data-testid="tareas-filtro-estado">
          <option value="">Todos los estados</option><option value="pendiente">Pendiente</option><option value="en_curso">En curso</option><option value="hecha">Hecha</option></select>
        <select value={f.prioridad} onChange={(e) => setF({ ...f, prioridad: e.target.value })} className={sel} data-testid="tareas-filtro-prioridad">
          <option value="">Todas las prioridades</option><option value="alta">Alta</option><option value="media">Media</option><option value="baja">Baja</option></select>
      </div>
      <div className="mt-6"><TaskList vista={vista} filtros={f} newSignal={sig} /></div>
      {nuevo && <TaskModal onClose={(ch) => { setNuevo(false); if (ch) setSig(sig + 1); }} />}
    </main>
  );
}
